var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('color-picker',_vm._b({attrs:{"selected":_vm.selected,"history-colors":_vm.colorsSelected,"current-color":_vm.currentColor},on:{"save":_vm.onSave,"select":_vm.selectColor}},'color-picker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }